import React from 'react';
import styled from 'styled-components';
import { colors, Regular } from './Styles';

type Props = {
  icon?: React.FC<React.SVGProps<SVGSVGElement>>;
  iconOverride?: React.ReactNode;
  text?: string;
  textOverride?: React.ReactNode;
};

export const RhIconText = (props: Props) => {
  return (
    <Container>
      {props.iconOverride
        ? props.iconOverride
        : !!props.icon && <props.icon fontSize={20} fill={colors.primary} />}
      {props.textOverride ? props.textOverride : <Regular weight="600">{props.text}</Regular>}
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  align-items: center;
  & > :not(:last-child) {
    margin-right: 10px;
  }
`;
